import { render, staticRenderFns } from "./RightMenu.vue?vue&type=template&id=2d2ad73b&scoped=true"
import script from "./RightMenu.vue?vue&type=script&lang=ts"
export * from "./RightMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2ad73b",
  null
  
)

export default component.exports